import { render, staticRenderFns } from "./ModalARouter.vue?vue&type=template&id=5cb2d3a9"
import script from "./ModalARouter.vue?vue&type=script&lang=js"
export * from "./ModalARouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports